import { render, staticRenderFns } from "./RemoteMonitoringIndicatorUnits.vue?vue&type=template&id=b3735b68"
import script from "./RemoteMonitoringIndicatorUnits.vue?vue&type=script&lang=js"
export * from "./RemoteMonitoringIndicatorUnits.vue?vue&type=script&lang=js"
import style0 from "./RemoteMonitoringIndicatorUnits.vue?vue&type=style&index=0&id=b3735b68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports